$(function() {
	$('.pagination li').addClass('page-item');
	$('.pagination li a').addClass('page-link');
	$('.pagination span').addClass('page-link');
});
